import React, { Suspense } from 'react';
import Body from '../../Components/Body';
import CheckDetails from '../../Components/CheckDetails';
import ExpandedView from '../../../Fireboard/components/ExpandedView/index';
import FullWidthModal from '../../../common/Modal/FullWidthModal';
import Popup from '@components/common/Popup/Popup';
import PopupContent from '@components/common/Popup/PopupContent/index';
import { useOutletContext } from 'react-router-dom';
import Loader from '@components/common/Loader/newLoaderModal';
import EmailReceipt from '../../../common/EmailReceipt/index';
import SmsReceipt from '../../../common/SmsReceipt/index';
import BulkTextToPay from '../../../Fireboard/components/BulkTextToPay/index';
import OutOfStock from '../../../../reducers/fireboard/outOfStock';
import style from '../../../Fireboard/views/Desktop/desktop.module.css';
import constant from '@components/common/globalization';
import MovePopup from '../../Components/MoveSlot/index';
import CubbyHeader from '../../Components/Header/index';

const Desktop = props => {
  const {
    popup,
    isExpanded,
    setIsExpanded,
    setPopup,
    currency,
    countryCode,
    twoDimensionSlot,
    onMoveSlotOrder,
  } = props;
  const {
    emailReceiptHandler,
    smsReceiptHandler,
    updateOrderStatus,
  } = useOutletContext();

  const getPopupContent = () => {
    if (!popup) return null;
    switch (popup.type) {
      case constant.EMAIL_RECEIPT:
        return (
          <EmailReceipt setPopup={setPopup} onSubmit={emailReceiptHandler} />
        );
      case constant.SMS_RECEIPT:
        return (
          <SmsReceipt
            setPopup={setPopup}
            onSubmit={smsReceiptHandler}
            defaultPhoneNumber={popup.metaData?.phoneNumber}
            defaultCountryCode={popup.metaData?.countryCode}
          />
        );
      case constant.BULK_TEXT_TO_PAY:
        return <BulkTextToPay currency={currency} countryCode={countryCode} />;
      case constant.OUT_OF_STOCK:
        return <OutOfStock setPopup={setPopup} />;
      case constant.MOVE_SLOT:
        return (
          <MovePopup
            setPopup={setPopup}
            twoDimensionSlot={twoDimensionSlot}
            onMoveSlotOrder={onMoveSlotOrder}
          />
        );
      default: {
        return <PopupContent {...popup} />;
      }
    }
  };
  const getPopupViewType = () => {
    if (!popup) return null;
    let isFullWidth = false;
    switch (popup.type) {
      case constant.EMAIL_RECEIPT:
        isFullWidth = false;
        break;
      case constant.SMS_RECEIPT:
        isFullWidth = false;
        break;
      case constant.BULK_TEXT_TO_PAY:
        isFullWidth = true;
        break;
      case constant.OUT_OF_STOCK:
        isFullWidth = true;
        break;
      case constant.NOTIFICATIONS:
        isFullWidth = true;
        break;
      case constant.MOVE_SLOT:
        isFullWidth = true;
        break;
      default: {
        isFullWidth = false;
        break;
      }
    }
    return isFullWidth;
  };

  return (
    <div className="row mx-0 h-100">
      <Popup visible={!!popup} fullPopupView={getPopupViewType()}>
        {getPopupContent()}
      </Popup>
      <Suspense fallback={<Loader />}>
        <FullWidthModal
          isOpen={isExpanded}
          customClass={style.modalContainerBg}
          customClass2="h-100"
          style={{ height: '100%' }}
        >
          <ExpandedView
            {...props}
            setIsExpanded={setIsExpanded}
            isExpanded={isExpanded}
            updateOrderStatus={updateOrderStatus}
          />
        </FullWidthModal>
      </Suspense>
      <>
        <CubbyHeader {...props} />
        <Body {...props} />
      </>
      <CheckDetails selectedItem={props?.selectedCheck} updateOrderStatus={updateOrderStatus} {...props} />
    </div>
  );
};

export default Desktop;
